import React from 'react'
import Header from '../Integration/Header'
import NoUserAccount from "../Integration/NouserErro"
export default function PageUserErro() {
  return (


    <div>
        
    <Header/>
        <NoUserAccount/>
        </div>
  )
}
